import { SERVER_URL } from "../../config";
import request from "../request";


// LOGIN API
export const adminLogin = (data) => {
    return new Promise(async (resolve, reject) => {
      await request
        .post(SERVER_URL + "auth/login", data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

// REGISTRATION API
export const adminRegister = (data) => {
    return new Promise(async (resolve, reject) => {
      await request
        .post(SERVER_URL + "auth/register", data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };


// Add Registration
export const addRegistration = (data) => {
    return new Promise(async (resolve, reject) => {
      await request
        .post("registration/", data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Edit Registration Details By Id
  export const editRegistrationDetailsById = (id, body) => {
    return new Promise(async (resolve, reject) => {
      await request
        .put(`registration/` + id, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Update Registration Details Status By Id
  export const patchRegistrationDetailsStatusById = (id, body) => {
    return new Promise(async (resolve, reject) => {
      await request
        .patch(`registration/` + id, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Update Registration Details SEND EMAIL
  export const patchRegistrationDetailsSendEmailById = (id, body) => {
    return new Promise(async (resolve, reject) => {
      await request
        .patch(`registration/sendEmail/` + id, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Get Registration List
  export const getRegistrationList = (data) => {
    return new Promise(async (resolve, reject) => {
      await request
        .get(`/registration`, { params: data })
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Get Registration Details By Id
  export const getRegistrationDetails = (id) => {
    return new Promise(async (resolve, reject) => {
      await request
        .get(`registration/` + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Delete Registration Details By Id
  export const deleteRegistration = (id) => {
    return new Promise(async (resolve, reject) => {
      await request
        .delete(`registration/` + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  